import React from 'react';
import Image from 'next/image';

export interface FormFieldInformationalImageProps {
    attachmentID: string | null;
    resolveImageSrc: (attachmentID: string) => string;
}

function FormFieldInformationalImage({ attachmentID, resolveImageSrc }: FormFieldInformationalImageProps) {
    if (!attachmentID) return null;
    return (
        <div style={{ position: 'relative', minHeight: 300, width: '100%' }}>
            <Image src={resolveImageSrc(attachmentID)} alt="" fill style={{ objectFit: 'contain' }} />
        </div>
    );
}

export default React.memo(FormFieldInformationalImage);
